const _ = require("lodash");
angular.module("AccountingBoxApp").component("vendorForm", {
  templateUrl: "app/components/vendorForm/vendorForm.html",
  controller: vendorFormController,
  bindings: {
    vendor: "=",
    purchase: "=",
    onSubmit: "&"
  }
});

function vendorFormController(Vendor) {
  let ctrl = this;

  const emptyArray = []

  ctrl.$onInit = function() {
    if (ctrl.vendor) {
      ctrl.vendor.bankAccountNumbers = ctrl.vendor.bankAccountNumbers || [];
      if (ctrl.vendor.bankAccountNumbers.length === 0) {
        ctrl.addBankAccountNumber();
      }
    }
  };

  ctrl.addBankAccountNumber = function() {
    let bankAccountNumbers = ctrl.vendor.bankAccountNumbers;
    bankAccountNumbers.push("");
    ctrl.vendor.bankAccountNumbers = _.uniq(bankAccountNumbers);
  };

  ctrl.onSuggestionSelect = function($item, $model, $label) {
    if($item && !ctrl.vendor.address?.line1) {
      ctrl.vendor.address = $item;
    }
  }

  function filterAddress(input) {
    return input.filter(address => !!address.addressee);
  }

  const filterAddressMemoized = _.memoize(filterAddress, function resolver() {
    return JSON.stringify(arguments);
  });

  ctrl.addressAddresseeSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.addresses) return emptyArray
    return filterAddressMemoized(ctrl.purchase.Attachment.extractedData.addresses);
  }

  ctrl.addressSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.addresses) return emptyArray
    return ctrl.purchase.Attachment.extractedData.addresses;
  }

  ctrl.onSuggestionSelectAddress = function($item, $model, $label) {
    ctrl.vendor.address = $item;
  }

  ctrl.bankAccountSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.bankAccountNumbers) return emptyArray
    return ctrl.purchase.Attachment.extractedData.bankAccountNumbers;
  }

  ctrl.companyRegistrationNumberSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.companyRegistrationNumbers) return emptyArray
    return ctrl.purchase.Attachment.extractedData.companyRegistrationNumbers;
  }

  ctrl.vatIdentificationNumberSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.vatIdentificationNumbers) return emptyArray
    return ctrl.purchase.Attachment.extractedData.vatIdentificationNumbers;
  }

  ctrl.emailSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.emails) return emptyArray
    return ctrl.purchase.Attachment.extractedData.emails;
  }

  ctrl.websiteSuggestions = function() {

    let websites = ctrl.purchase?.Attachment?.extractedData?.websites || []
    if(ctrl.purchase?.Attachment?.extractedData?.emails) {
      websites = _.uniq(websites.concat(ctrl.purchase.Attachment.extractedData.emails.filter(e=> e.match("@") && !e.match(/@(gmail|hotmail|outlook|live|yahoo|icloud|me|msn|aol|kpn|ziggo)/)).map(email => {
        return `www.${email.split('@')[1]}`; // TODO prevent current company domain from being added
      })));
    }
    return websites;
  }

  ctrl.phoneNumberSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.phoneNumbers) return emptyArray
    return ctrl.purchase.Attachment.extractedData.phoneNumbers;
  }

  ctrl.paymentTermSuggestions = function() {
    if(!ctrl.purchase?.Attachment?.extractedData?.paymentTerms) return emptyArray
    return ctrl.purchase.Attachment.extractedData.paymentTerms;
  }

  ctrl.addBankAccountNumber = function() {
    let bankAccountNumbers = ctrl.vendor.bankAccountNumbers;
    bankAccountNumbers.push("");
    ctrl.vendor.bankAccountNumbers = _.uniq(bankAccountNumbers);
  };

  ctrl.onCompanySelect = function(company) {
    company = _.assign(ctrl.vendor, company);
    ctrl.vendor = new Vendor(company);
  };
}
